import Minigames, { MG_TYPES } from "@/js/Minigames/Minigames";
import { useEffect, useState } from 'react';
import DragDrop, { DragDropImage } from "./DragDrop/DragDrop";
import Qcm from "./Qcm/Qcm";


import Popup from '@/components/shared/Popup/Popup';
import classes from './PopupMinigameSequence.module.css';
import { observer } from "mobx-react-lite";
import SoundPlayer from "react-sdk/SoundPlayer";
import Swipe from "./Swipe/Swipe";
import Activity from "./Activity/Activity";


const PopupMinigameSequence = () => {

  let mg = Minigames.current

  let elementRef = mg?.elementRef

  // NOTE c'est pour les sequences de QCM/DragDrop, on stocke ici l'index de l'element actuel
  const [currentElementIndex, setCurrentElementIndex] = useState(null);

  function onFinished() {

    Minigames.stop()
  }

  useEffect(() => {
    SoundPlayer.playSound("music_MG")
  }, []);



  return (
    <Popup className={classes.PopupMinigameSequence} >

      {elementRef !== null && mg.type === MG_TYPES.QUIZ &&
      <Activity
      key={elementRef.ID}
      instance={elementRef}
      GameComponent={Qcm}
      onFinished={onFinished} />}

      {elementRef !== null && mg.type === MG_TYPES.DRAGDROP &&
      <Activity
      key={elementRef.ID}
      instance={elementRef}
      GameComponent={DragDrop}
      onFinished={onFinished} />}

      {elementRef !== null && mg.type === MG_TYPES.DRAGDROP_IMAGE &&
      <Activity
      key={elementRef.ID}
      instance={elementRef}
      showMediaInTitle={false}
      GameComponent={DragDropImage}
      onFinished={onFinished} />}

      {elementRef !== null && mg.type === MG_TYPES.SWIPE &&
      <Activity
      key={elementRef.ID}
      instance={elementRef}
      GameComponent={Swipe}
      onFinished={onFinished} />}

    </Popup>
  )
}

export default observer(PopupMinigameSequence)
